import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  AccessibleGraphQLObject,
  AccessibleGraphQLApiIdObject,
  getAccessibleOrInaccessibleId,
  getAccessibleOrInaccessibleApiId,
} from 'graphql-client/InaccessibleInfo';
import {FONT_PROXIMA_13} from 'styles/FontConstants';
import {BORDER_RADIUS_DEFAULT} from 'styles/StyleConstants';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';

import {InaccessibleInfoGraphQL} from '../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';

interface DataCatalogOriginProps {
  originType: string;
  lineageParent: AccessibleGraphQLObject | InaccessibleInfoGraphQL | AccessibleGraphQLApiIdObject | null;
}

export default function DataCatalogOrigin({originType, lineageParent}: DataCatalogOriginProps): JSX.Element {
  if (lineageParent == null) {
    return <span className={css(styles.originType)}>{originType}</span>;
  }

  // TODO(BNCH-98925): remove this once RunNode is updated to have api_identifier in id instead of apiId
  let id;
  if (originType === 'RUN') {
    id = getAccessibleOrInaccessibleApiId(lineageParent as AccessibleGraphQLApiIdObject);
  } else {
    id = getAccessibleOrInaccessibleId(lineageParent as AccessibleGraphQLObject);
  }

  return <BenchChip id={id} size={ChipSize.SMALL} className="chip-container" />;
}

const styles = StyleSheet.create({
  originType: {
    backgroundColor: Color.GRAY_200,
    borderColor: Color.GRAY_200,
    borderStyle: 'solid',
    borderRadius: BORDER_RADIUS_DEFAULT,
    borderWidth: '2px 4px',
    color: Color.GRAY_900,
    ...FONT_PROXIMA_13,
  },
});
